import { render, staticRenderFns } from "./PagamentoPaypal.vue?vue&type=template&id=1051f83c&"
import script from "./PagamentoPaypal.vue?vue&type=script&lang=js&"
export * from "./PagamentoPaypal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports